import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, viewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from "../../../../common/base-detail.component";
import { Address } from "../../../../generated/generated-types";
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { WidgetAddressContactLinkListComponent } from '../widget-address-contact-link-list/widget-address-contact-link-list.component';

@Component({
  selector: 'formly-crm-companyContactLink-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formly-crm-companyContactLink-list.component.html',
  hostDirectives: [FormlyFillHeightListHostDirective],
  standalone: true,
  imports: [
    WidgetAddressContactLinkListComponent,
    BlockableDiv,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
export class FormlyCrmCompanyContactLinkListComponent extends FieldType {
  destroyRef = inject(DestroyRef);

  companyContactLinkWidget = viewChild(WidgetAddressContactLinkListComponent);

  isSaving = false;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
    this.destroyRef.onDestroy(() => {
      console.log(`Destroying ${this.constructor.name} component...`)
    });
  }

  checkIfCanSave(): boolean {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode(): Promise<void> {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error("No detail component found to save AddressContactLink");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }
}
